import { FullProfileData } from '../../api/api'
import { axios } from '../../api/axios'

const generatePdf = (data: FullProfileData) => {
    return axios.post('/pub/v2/pdf', { data }, { responseType: 'blob' })
}

export { generatePdf }
